// This file is autogenerated from /frontend/sail-next/packages/docs/src/markdoc/demo/checkbox/index.tsx with go/sail-next-tailor-docs-publisher 

import * as React from 'react';
import { Actions } from './Actions.story';
import { Dismiss } from './Dismiss.story';
import { Basic } from './Basic.story';
const basic = {
  rendered: <Basic />,
  source: `
<Box css={{
  layout: 'column',
  gap: 'medium'
}}>
  <Notice
    type="neutral"
    onDismiss={() => console.log('hello world')}
    title="Neutral title"
    description="A short description"
    actions={
      <Button onPress={() => console.log('hello world')}>
        Button
      </Button>}    
  />

  <Notice 
    type="attention"
    title="Attention notice"
    description="Automatically sets the icon to a warning circle and the color to yellow"
    onDismiss={() => console.log('hello world')}
  />

  <Notice
    type="negative"
    title="Negative notice"
    description="Automatically sets the icon to a warning triangle and the color to red."  
  />

  <Notice 
    type="positive"
    title="Positive notice"
    description="Automatically sets the icon to a checkmark and the color to green."
    onDismiss={() => console.log('hello world')}
    actions={<Button onPress={() => console.log('hello world')}>Accept</Button>} 
  />
</Box>`
};
const actions = {
  rendered: <Actions />,
  source: `
<Notice 
  type="neutral"
  title="Check your bank account information"
  description="If you believe the bank account information you 
  provided is incorrect or out of date, simply edit your bank 
  account information and Stripe will automatically attempt your payouts again."
  actions={<Button onPress={() => console.log('hello world')}>Update bank account</Button>} 
/>`
};
const dismiss = {
  rendered: <Dismiss />,
  source: `
<Notice
  type="neutral"
  onDismiss={() => console.log('hello world')}
  title="Neutral title"
  description="A short description"
  actions={<Button onPress={() => console.log('hello world')}>Button</Button>} 
/>;`
};


export const NoticeExamples = {basic, actions, dismiss}
